<template>
	<div>
		
		
		<!-- 普通页面 -->
		<div v-if="$route.path=='/home'||
		$route.path=='/dynamic'||
		$route.path=='/newsList'||
		$route.path=='/industryList'||
		$route.path=='/safetyList'||
		$route.path=='/skillList'||
		$route.path=='/exhibition'||
		$route.path=='/peixunTxt'||
		$route.path=='/dangTxt'||
		$route.path=='/dynamicMsg'||
		$route.path=='/study'||
		$route.path=='/studyMsg'||
		$route.path=='/cardSeach'||
		$route.path=='/download'">
			<!-- 头部 PC -->
			<div class="headbox fcss">
				<Headbox/>
			</div>
			<!-- 内容 -->
			<div class="home_msg">
				<router-view />
			</div>
		</div>
		
		
		<!-- 登录/注册/视频/考试 -->
		<div v-else-if="$route.path=='/login'||
		$route.path=='/reg'||
		$route.path=='/qyInfoRemake'||
		$route.path=='/cpwd'||
		$route.path=='/classProblem'||
		$route.path=='/classShuati'||
		$route.path=='/classTest'||
		$route.path=='/classVideo'">
			<!-- 头部 PC -->
			<!-- <div class="headbox fcss">
				<Headbox/>
			</div> -->
			<!-- 内容 -->
			<div class="home_msg">
				<router-view />
			</div>
		</div>
		
		
		<!-- 后台页面 -->
		<div v-else>
			<!-- 无侧栏 -->
			<div class="home_msgU" v-if="$route.path=='/userNews'">
				<div class="r" style="width: 100%;">
					<userHead/>
					<div class="msg">
						<router-view />
					</div>
				</div>
			</div>
			<!-- 有侧栏 -->
			<div class="home_msgU" v-else>
				<div class="l">
					<userLeft/>
				</div>
				<div class="r">
					<userHead/>
					<div class="msg">
						<router-view />
					</div>
				</div>
			</div>
		</div>
		
		
		<!-- 底部 -->
		<div class="Footbox" v-if="isfot&&$route.path!='/login'&&$route.path!='/reg'&&$route.path!='/cpwd'&&$route.path!='/classProblem'&&$route.path!='/classTest'&&$route.path!='/classVideo'">
			<Footbox/>
		</div>
		
		
	</div>
</template>
<script>
import { login } from "/src/api/api.js"
import Headbox from '@/components/head.vue';
import Footbox from '@/components/foot.vue';
import userHead from '@/components/userHead.vue';
import userLeft from '@/components/userLeft.vue';
export default {
	components:{Headbox,Footbox,userHead,userLeft},
	data(){
		return {
			isfot:true,
		}
	},
	watch: {
		'$route': function(n,o) {
			// this.isfot = false
			// setTimeout(()=>{
			// 	this.isfot = true
			// },1500)
		}
	},
	mounted() {
		// setTimeout(()=>{
		// 	this.isfot = true
		// },1500)
	},
	methods:{
		
	}
}
</script>
<style lang="scss">
body{
	background: #F7F2EC;
}
</style>
<style lang="scss" scoped>
.home_msgU{
	display: flex;
	align-items: stretch;
	min-height: 700px;
	.l{
		width: 266px;
		background: #3B6492;
	}
	.r{
		width: calc(100% - 266px);
		padding-bottom: 40px;
		position: relative;
		z-index: 3;
		.msg{
			// height: 877px;
			// overflow-y: scroll;
			// .jkh{
			// 	height: 1600px;
			// 	font-size: 1000px;
			// 	background: pink;
			// }
			// background: pink;
		}
	}
}
</style>